
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"12","viewBox":"0 0 17 10","fill":"#DEDEDE","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke-width":".1","stroke":"#fff","d":"M7.54 7.172H2.46l-1.052 2.39H0L4.33 0h1.353l4.344 9.563H8.593L7.54 7.172zm-.477-1.093L5 1.393 2.937 6.08h4.126zM13.899 2.254c1.002 0 1.767.246 2.295.738.537.492.806 1.225.806 2.2v4.37h-1.243v-.956a2.11 2.11 0 01-.943.78c-.4.172-.879.259-1.434.259-.81 0-1.462-.196-1.954-.588-.482-.391-.724-.906-.724-1.543 0-.638.232-1.148.697-1.53.465-.392 1.202-.588 2.213-.588h2.076v-.26c0-.564-.163-.997-.491-1.297-.328-.3-.81-.451-1.448-.451-.428 0-.847.073-1.257.218-.41.137-.756.324-1.038.56l-.547-.983c.374-.3.82-.528 1.339-.683a5.457 5.457 0 011.653-.246zm-.3 6.38c.5 0 .933-.11 1.297-.328a1.95 1.95 0 00.792-.956V6.339h-2.021c-1.111 0-1.667.373-1.667 1.12 0 .364.141.651.424.86.282.21.674.315 1.174.315z"}})])
          )
        }
      }
    